import React from 'react'
import PropTypes from 'prop-types'

import cl from 'classnames'

import Stars from './Stars'

const initials = (name) =>
  name
    .split(/\s+/)
    .map((word) => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()

// The widget's icon for a third-party source, e.g. "Google Local" → icon-google-local.svg
const sourceIconUrl = (source) =>
  `https://assets.reviews.io/img/all-global-assets/platform-logos/icon-${source.toLowerCase().replace(/\s+/g, '-')}.svg`

const Badge = ({ icon, text }) => (
  <div className='R-BadgeElement R-flex-row R-flex-row--noMargin R-flex-middle-xxs R-flex-start-xxs'>
    <div className='R-BadgeElement__icon R-IconButton R-IconButton--lg u-marginLeft--neg--xs'>{icon}</div>
    <div className='R-BadgeElement__text R-TextBody R-TextBody--xxxxs R-TextBody--inline u-textLeft--all u-marginBottom--none u-verticalAlign--middle'>
      <div className='cssVar-badgeElement__text'>{text}</div>
    </div>
  </div>
)

Badge.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
}

// A review in the REVIEWS.io widget's markup (Polaris build 205), styled by its stylesheet
const ReviewCard = ({ author, date, dateLabel, rating, verified, body, location, source }) => (
  <article className='R-ContentList__item u-textLeft--all u-positionRelative'>
    <div className='item__meta'>
      <div className='u-marginBottom--md c-meta__authorDetails'>
        <div aria-hidden='true' className='R-AvatarThumbnail u-marginBottom--xs'>
          <div className='R-AvatarThumbnail__inner'>
            <div className='R-TextHeading R-TextHeading--xs u-marginBottom--none'>{initials(author)}</div>
          </div>
        </div>
        {source ? (
          <Badge
            icon={<img src={sourceIconUrl(source)} alt={`${source} logo`} style={{ width: '100%' }} />}
            text={source}
          />
        ) : (
          verified && (
            <Badge
              icon={
                <span
                  className='ricon-badge--checkmark R-IconButton__icon cssVar-badgeElement__icon'
                  aria-hidden='true'
                />
              }
              text='Verified Customer'
            />
          )
        )}
        <div
          className={cl('R-TextHeading R-TextHeading--xxs u-textLeft--all cssVar-authorName c-meta__authorName', {
            'u-displayInlineFlex R-flex-middle-xxs': source,
          })}
        >
          <span className='cssVar-authorName'>{author}</span>
        </div>
        {location && (
          <div className='R-TextBody R-TextBody--xxxxs u-textLeft--all u-marginBottom--none c-meta__authorLocation'>
            {location}
          </div>
        )}
      </div>
    </div>
    <div className='item__review'>
      <div className='item__inner'>
        <div className='u-marginBottom--md'>
          <Stars rating={rating} />
          {body ? (
            <div className='R-TextBody R-TextBody--xs u-textLeft--all u-whiteSpace--prewrap u-marginBottom--none'>
              {body}
            </div>
          ) : (
            <div className='R-TextBody R-TextBody--xs u-textLeft--all u-marginBottom--none'>
              <em>Reviewer didn&apos;t leave any comments</em>
            </div>
          )}
        </div>
        <div className='R-flex-row R-flex-row--noMargin R-flex-between-xxs R-flex-bottom-xxs'>
          <div className='u-marginBottom--sm u-flexGrow c-reviewDateTime'>
            <div className='R-TextBody R-TextBody--xxxs u-textRight--all u-marginBottom--none'>
              <time dateTime={date}>{dateLabel}</time>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
)

ReviewCard.propTypes = {
  author: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  dateLabel: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  verified: PropTypes.bool.isRequired,
  body: PropTypes.string.isRequired,
  location: PropTypes.string,
  source: PropTypes.string,
}

export default ReviewCard
